import Table from "@base/Table/Table"

export default Table;
